(function () {
  'use strict';
  const configElement = document.getElementById('CartUpgradeConfig');
  const template = document.getElementById('CartUpgradeTemplate');
  const drawer = document.getElementById('CartDrawer');
  const feedback = document.getElementById('CartUpgradeFeedback');
  if (!configElement || !template || !drawer || !feedback) return;
  const config = JSON.parse(configElement.textContent);
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let busy = false;
  let disabledControls = [];
  const eligible = function (cart) {
    if (!cart || cart.item_count !== 1 || !Array.isArray(cart.items) || cart.items.length !== 1) return false;
    const item = cart.items[0];
    return Number(item.variant_id) === Number(config.sourceVariant) && item.quantity === 1 &&
      !item.selling_plan_allocation && !item.parent_relationship &&
      Object.keys(item.properties || {}).length === 0;
  };
  const message = function (text, error) {
    feedback.textContent = text;
    feedback.hidden = !text;
    feedback.classList.toggle('visually-hidden', Boolean(text) && !error);
  };
  const render = function (cart) {
    drawer.querySelectorAll('.cart-upgrade').forEach(function (element) { element.remove(); });
    const scrollable = drawer.querySelector('#CartContainer .drawer__scrollable');
    if (scrollable && eligible(cart) && template.content.querySelector('[data-cart-upgrade]')) {
      scrollable.appendChild(template.content.cloneNode(true));
    }
  };
  document.addEventListener('cart:updated', function (event) {
    render(event.detail && event.detail.cart);
    if (!busy) message('', false);
  });
  const request = async function (path, body) {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(config.error);
    return data;
  };
  const refresh = function () {
    return new Promise(function (resolve, reject) {
      const done = function (event) {
        clearTimeout(timer);
        document.removeEventListener('cart:updated', done);
        resolve(event.detail.cart);
      };
      const timer = setTimeout(function () {
        document.removeEventListener('cart:updated', done);
        reject(new Error(config.error));
      }, 10000);
      document.addEventListener('cart:updated', done);
      document.dispatchEvent(new CustomEvent('cart:build'));
    });
  };
  const setBusy = function (value) {
    busy = value;
    drawer.toggleAttribute('data-upgrade-busy', value);
    drawer.setAttribute('aria-busy', String(value));
    if (value) {
      disabledControls = [...drawer.querySelectorAll('#CartContainer button, #CartContainer input, #CartContainer select, #CartContainer textarea')]
        .filter(function (control) { return !control.disabled; });
      disabledControls.forEach(function (control) { control.disabled = true; });
    } else {
      disabledControls.forEach(function (control) { if (control.isConnected) control.disabled = false; });
      disabledControls = [];
    }
  };
  drawer.addEventListener('submit', function (event) {
    if (busy) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  drawer.addEventListener('click', async function (event) {
    if (busy && event.target.closest('#CartContainer')) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    const button = event.target.closest('[data-cart-upgrade]');
    if (!button || !drawer.contains(button)) return;
    event.preventDefault();
    if (drawer.querySelector('#CartContainer.is-loading')) return;
    const variantId = Number(button.dataset.cartUpgrade);
    if (!config.variants.some(function (id) { return Number(id) === variantId; })) return;
    const originalLabel = button.textContent;
    setBusy(true);
    message(config.loading, false);
    button.textContent = config.loading;
    try {
      const before = await request('cart.js');
      if (!eligible(before)) {
        await refresh();
        message(config.changed, true);
        return;
      }
      const updates = { [before.items[0].key]: 0, [String(variantId)]: 1 };
      await request('cart/update.js', { updates: updates });
      const after = await refresh();
      if (after.items.some(function (item) { return Number(item.variant_id) === Number(config.sourceVariant); }) ||
          !after.items.some(function (item) { return Number(item.variant_id) === variantId && item.quantity === 1; })) {
        throw new Error(config.error);
      }
      message(config.success, false);
      const checkout = drawer.querySelector('.cart__checkout');
      if (checkout) checkout.focus({ preventScroll: true });
    } catch (error) {
      try { await refresh(); } catch (refreshError) { /* A page reload remains available if the connection fails. */ }
      message(config.error, true);
    } finally {
      if (button.isConnected) button.textContent = originalLabel;
      setBusy(false);
    }
  }, true);
}());
